import React from "react";
// import { useSessionStorage } from "./UIChatStorage";
const LazyGroupSticker = ({
  type,
  src,
  handleClick,
  id,
} : any) => {

  return (
    <img
      id={type === "sticker" ? id : ""}
      width="100%"
      height="100%"
      src={src}
      onClick={type === "sticker" ? handleClick : undefined}
    />
  );
};
export default React.memo(LazyGroupSticker);
